import React from 'react'

const Nbsp: React.FC = () => <>{'\u00A0'}</>

export default Nbsp
